import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { Dossie } from '../models/dossie.model';
import { DossieRequest } from '../models/dossie-request.model';
import { PerfilDossie } from '../models/perfil-dossie.model';
import { DossieListParams } from '../models/dossie-list-params.model';
import { PaginatedResponse } from '../../../core/shared/models/pagination.model';

export const DOSSIER_REPOSITORY = new InjectionToken<DossieRepository>('DossieRepository');

export interface DossieRepository {
  listarDossies(params: DossieListParams): Observable<PaginatedResponse<Dossie>>;
  buscarDossiePorId(id: number): Observable<Dossie>;
  criarDossie(payload: DossieRequest): Observable<Dossie>;
  atualizarDossie(id: number, payload: DossieRequest): Observable<Dossie>;
  excluirDossie(id: number): Observable<void>;
  listarPerfisDossie(): Observable<PerfilDossie[]>;
}
